export const ValidatorKey = ({ size = 24, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16.4917 12.4417C14.775 14.1501 12.3167 14.6751 10.1583 14.0001L6.23334 17.9167C5.95001 18.2084 5.39168 18.3834 4.99168 18.3251L3.17501 18.0751C2.57501 17.9917 2.01668 17.4251 1.92501 16.8251L1.67501 15.0084C1.61668 14.6084 1.80834 14.0501 2.08334 13.7667L6.00001 9.85006C5.33334 7.68339 5.85001 5.22506 7.56668 3.51672C10.025 1.05839 14.0167 1.05839 16.4833 3.51672C18.95 5.97506 18.95 9.98339 16.4917 12.4417Z"
      stroke="#00C48C"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.74167 14.575L7.65834 16.4916"
      stroke="#00C48C"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0833 9.16663C12.7737 9.16663 13.3333 8.60698 13.3333 7.91663C13.3333 7.22627 12.7737 6.66663 12.0833 6.66663C11.393 6.66663 10.8333 7.22627 10.8333 7.91663C10.8333 8.60698 11.393 9.16663 12.0833 9.16663Z"
      stroke="#00C48C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
